import { z } from "zod";
import { localeSchema } from "./common";

export const tenantIdSchema = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[a-z0-9-]+$/);
export type TenantId = z.infer<typeof tenantIdSchema>;

export const partnerClinicSchema = z.object({
  id: z.string(),
  name: z.string(),
  supportedLocales: z.array(localeSchema).min(1),
  webdocClinicRef: z.string().optional(),
});
export type PartnerClinic = z.infer<typeof partnerClinicSchema>;
